import type { FunctionComponent } from 'react'
import { SimpleJson } from './SimpleJson'

export const SimpleError: FunctionComponent<React.PropsWithChildren<{
  msg: string
  json?: any
}>> = ({ msg, json }) => {
  return (
    <>
      <div className="bg-red-200 p-4">
        <div className="pb-3 text-lg font-extrabold">{msg}</div>
        {json && <SimpleJson value={json} />}
      </div>
    </>
  )
}
